module.exports = require("@common-stack/client-react");